import DSChip from "views/system-design/DSChip";
import DSTooltip from "views/system-design/DSTooltip";
import { Ticket, STATUS_COLORS } from "../../types";

interface TicketChipProps {
  ticket: Ticket;
  onSelectTicket: (ticket: Ticket) => void;
}

export default function TicketChip({
  ticket,
  onSelectTicket,
}: TicketChipProps) {
  return (
    <DSTooltip title={`${ticket.key} — ${ticket.title}`}>
      <DSChip
        label={ticket.title}
        size="small"
        onClick={(event) => {
          event.stopPropagation();
          onSelectTicket(ticket);
        }}
        sx={{
          maxWidth: "100%",
          justifyContent: "flex-start",
          bgcolor: STATUS_COLORS[ticket.status],
          color: "common.white",
          fontWeight: 500,
          fontSize: 11,
          height: 22,
          "& .MuiChip-label": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            px: 0.75,
          },
          "&:hover": { opacity: 0.85 },
        }}
      />
    </DSTooltip>
  );
}
